module.exports = __webpack_public_path__ + "static/icons/icon-webcam--black-0ff4cf3cf56fd0a33d3f118269c35571.svg";